import React from "react";

const FilterOption = ({
  id,
  label,
  checked,
  disabled,
  title,
  onChange,
}) => (
  <label className="filters-panel__option" htmlFor={id} title={title}>
    <input
      type="checkbox"
      className="filters-panel__checkbox"
      id={id}
      checked={checked}
      disabled={disabled}
      onChange={onChange}
    />
    <span className="filters-panel__option-label">{label}</span>
  </label>
);

const FilterColumn = ({ title, children }) => (
  <div className="filters-panel__column">
    <h6 className="filters-panel__column-title">{title}</h6>
    <div className="filters-panel__options">{children}</div>
  </div>
);

const SearchFilters = ({
  selectedTypes,
  selectedProviders,
  selectedPrice,
  selectedSizes,
  selectedAmount,
  toggleSelection,
  onApplyFilters,
  printingProviders,
}) => {
  return (
    <div className="filters-panel__content">
      <h5 className="filters-panel__subtitle">Filter by</h5>

      <div className="filters-panel__grid">
        <FilterColumn title="Type">
          {["AI", "Real", "3D", "Mix"].map((type) => (
            <FilterOption
              key={type}
              id={`type-${type}`}
              label={type}
              checked={selectedTypes.includes(type)}
              disabled={
                selectedTypes.length === 1 && selectedTypes.includes(type)
              }
              title={
                selectedTypes.length === 1 && selectedTypes.includes(type)
                  ? "Select another type before clearing this one"
                  : undefined
              }
              onChange={() => toggleSelection(type, selectedTypes, "type")}
            />
          ))}
        </FilterColumn>

        <FilterColumn title="Print Provider">
          {printingProviders.map((provider) => (
            <FilterOption
              key={provider.id}
              id={`provider-${provider.id}`}
              label={provider.name}
              checked={selectedProviders.some((p) => p === provider.id)}
              disabled={
                selectedProviders.length === 1 &&
                selectedProviders.some((p) => p === provider.id)
              }
              title={
                selectedProviders.length === 1 &&
                selectedProviders.some((p) => p === provider.id)
                  ? "Select another provider before clearing this one"
                  : undefined
              }
              onChange={() =>
                toggleSelection(provider.id, selectedProviders, "provider")
              }
            />
          ))}
        </FilterColumn>

        <FilterColumn title="Price">
          {["Free", "Paid"].map((type) => (
            <FilterOption
              key={type}
              id={`price-${type}`}
              label={type}
              checked={selectedPrice.includes(type)}
              disabled={
                selectedPrice.length === 1 && selectedPrice.includes(type)
              }
              title={
                selectedPrice.length === 1 && selectedPrice.includes(type)
                  ? "Select Free or Paid before clearing this one"
                  : undefined
              }
              onChange={() => toggleSelection(type, selectedPrice, "price")}
            />
          ))}
        </FilterColumn>

        <FilterColumn title="Amount">
          {["Single", "Bundle"].map((type) => (
            <FilterOption
              key={type}
              id={`amount-${type}`}
              label={type}
              checked={selectedAmount.includes(type)}
              disabled={
                selectedAmount.length === 1 && selectedAmount.includes(type)
              }
              title={
                selectedAmount.length === 1 && selectedAmount.includes(type)
                  ? "Select Single or Bundle before clearing this one"
                  : undefined
              }
              onChange={() => toggleSelection(type, selectedAmount, "amount")}
            />
          ))}
        </FilterColumn>
      </div>

      <div className="filters-panel__actions">
        <button
          type="button"
          className="filters-panel__apply"
          onClick={() => onApplyFilters?.()}
        >
          Apply Filters
        </button>
      </div>
    </div>
  );
};

export default SearchFilters;
